import React, { useState, useEffect, useRef } from 'react';
import { Avatar } from 'primereact/avatar';
import { useHistory } from 'react-router-dom';
import { Storage } from 'aws-amplify';

import MessageBox from './MessageBox';
import CaseLeadContainer from '../CaseLeadContainer/CaseLeadContainer';
import ImageComponent from 'shared/ImageComponent';
import { listCasesForUser } from 'services/CaseServices';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { toastConstant } from 'constants/toastmessage';
import { useToast } from 'context/ToastContext';
import { handleRedirection } from 'utils/utils';
import { FILEUPLOAD_S3, FILEUPLOAD_S3_LEVEL, SetS3Config } from 'config/amplify_config';
import { uuidv4 } from 'common/uuidGenerator';
import { listMessageHistory, messageMarkRead, sendTextMessage } from 'services/messages/textMessageService';
import { useWebSocketContext } from 'context/WebSocketConnectionContext';
import { generateFullName } from 'utils/generateFullNameUtils';
import Cookies from 'universal-cookie';
import { useNavbarContext } from 'context/NavbarContext';
import { validateUpload } from 'services/fileManager/fileManagerServices';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
const cookie = new Cookies();

const tenantId = cookie.get('tenantId') || null;

const fileUpload = async (file, setUploadindStatus, idForFolder) => {
  const caseFolder = idForFolder ? `${idForFolder}/` : '';
  const file_location = `text_messaging/${tenantId}/${caseFolder}/${uuidv4()}#$#${encodeURIComponent(file?.name)}`;
  SetS3Config(FILEUPLOAD_S3, FILEUPLOAD_S3_LEVEL);

  setUploadindStatus(true);
  let response = await Storage.put(file_location, file, {
    contentType: file?.type,
    useAccelerateEndpoint: true,
  }).catch(() => setUploadindStatus(false));
  setUploadindStatus(false);

  if (response.key) {
    return response.key;
  } else {
    return false;
  }
};

export default function MessageContainer(props) {
  const {
    handleSelectThread,
    isFromCase,
    leadDetails,
    caseDetails,
    selectedThread,
    newThreadActive,
    navigateToLatest,
    setMessageThreads,
    onMountUnMount,
    onOperationBreak,
    fetchTextMessages,
    selectedContact,
    messageThreads,
    isFromLead,
  } = props;
  const history = useHistory();
  const { addToast } = useToast();
  const websocket = useWebSocketContext();
  const userContext = useUserDetailsContext();
  const listRef = useRef(null);

  const [caseLeadList, setCaseLeadList] = useState(null);
  const [file, setFile] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const [isClientOptIn, setIsClientOptIn] = useState(null);
  const [uploadindStatus, setUploadindStatus] = useState(false);
  const [isNewThread, setIsNewThread] = useState(false);

  const { notificationData } = useNavbarContext();

  useEffect(() => {
    if (websocket?.textMessageData?.body?.from) {
      if (
        selectedThread?.from_ === websocket?.textMessageData?.body?.from ||
        selectedThread?.to === websocket?.textMessageData.body?.from
      ) {
        const messageData = {
          from: websocket?.textMessageData?.body?.from,
          to: selectedThread?.to,
          body: websocket?.textMessageData?.body?.message_body,
          media_url: websocket?.textMessageData?.body?.media_url ?? websocket?.textMessageData?.body?.mms_path,
          MediaContentType0: websocket?.textMessageData?.body?.media_content_type ?? '',
          mms_path: websocket?.textMessageData?.body?.mms_path ?? '',
        };
        setMessages((preVal) => [...preVal, messageData]);
        websocket.setTextMessageData();
      }
    }
    // delivery status Update Logic
    if (websocket?.textMessageData?.body?.SmsSid) {
      setMessages((preVal) =>
        preVal.map((message) => {
          if (message?.message_id === websocket?.textMessageData?.body?.SmsSid) {
            return { ...message, last_message_status: websocket?.textMessageData?.body?.SmsStatus };
          } else return message;
        })
      );
    }
  }, [websocket?.textMessageData]);

  const fetchMessageHistory = (contactId, date, phoneNumber, _offset = 0, unreadReplyCount, isRead) => {
    setLoading(true);

    // Mark as read only on initial load (offset === 0) and when thread has a valid id
    if (_offset === 0 && (unreadReplyCount > 0 || isRead === true) && isNewThread === false && selectedThread?.id) {
      messageMarkRead({
        firm_user_id: userContext?.firmDetails?.firm_user_id,
        thread_ids: [selectedThread?.id],
      })
        .then(() => {
          setMessageThreads((preval) =>
            preval.map((val) => {
              if (val.contact_id === contactId) {
                return { ...val, unread_reply_count: 0 };
              } else return val;
            })
          );

          //Fetching notification counts
          notificationData?.loadNotificationCount();
        })
        .catch((err) => console.log(err));
    }

    listMessageHistory({
      contact_id: contactId,
      message_date: date,
      phoneNumber,
      limit: 50,
      offset: _offset,
    })
      .then((response) => {
        setIsClientOptIn(response?.data?.is_client_opt_in);

        if (response?.data?.text_message_history?.length) {
          const newMessages = response.data.text_message_history;

          // Check if there are more messages
          // next_token will be null if this is the last page
          if (response?.data?.next_token !== null && response?.data?.next_token !== undefined) {
            setCurrentOffset(response.data.next_token);
            setHasMoreMessages(true);
          } else {
            setHasMoreMessages(false);
          }

          // Messages come in descending order (newest first), need to reverse for chat display
          let reverseData = JSON.parse(JSON.stringify(newMessages));
          let finalData = reverseData.reverse();

          if (_offset === 0) {
            // Initial load - replace all messages
            setMessages(finalData);
          } else {
            // Pagination - prepend older messages
            setMessages((preVal) => [...finalData, ...preVal]);
          }
        } else {
          if (_offset === 0) {
            setMessages([]);
          }
          setHasMoreMessages(false);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setHasMoreMessages(false);
      });
  };

  const sendMessage = async ({ message }) => {
    isFromCase && typeof onMountUnMount === 'function' && onMountUnMount('text-message', 'mounted', caseDetails?.case_id);

    let sendData = {
      message_body: message,
      case_id: caseLeadList?.map((v) => v.case_id),
    };

    let file_path = '';
    let media_content_type = '';
    let display_filename = '';
    let size = 0;
    if (file) {
      const fileSize = file?.size;
      try {
        await validateUpload(fileSize);
      } catch (err) {
        let errorMsg = err?.response?.data?.message || err?.response?.data || err?.message || 'File validation failed';

        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, errorMsg);
        return;
      }
      const folderId = caseLeadList?.map((v) => v.case_id)[0] || '';
      let fileResponse = await fileUpload(file, setUploadindStatus, folderId);

      if (fileResponse) {
        file_path = `public/${fileResponse}`;
        media_content_type = file.type;
      }

      display_filename = file?.name || '';
      size = file?.size || 0;
    }

    if (isFromCase) {
      sendData.text_message_case_id = caseDetails?.case_id;
    }
    let timeout;

    await sendTextMessage({
      contact_id: selectedThread?.contact_id,
      text_message_thread_sk: isNewThread ? '' : selectedThread?.sk ? selectedThread?.sk?.replaceAll('#', '%23') : '',
      file_path,
      media_content_type,
      display_filename,
      size: size?.toString(),
      data: sendData,
      is_lead: isFromLead,
    })
      .then((response) => {
        if (response?.data?.status === 'Failed') {
          addToast(
            false,
            toastConstant.toasterType.ERROR,
            toastConstant.api.FAILED,
            'Failed to send the message. Please provide a valid phone number.'
          );
          isFromCase && typeof onOperationBreak === 'function' && onOperationBreak();
        } else {
          timeout = setTimeout(() => {
            isFromCase && typeof onMountUnMount === 'function' && onMountUnMount('text-message', 'unmounted');
          }, 3000);
          // add last message in list
          setMessages((preVal) => [...preVal, { ...response?.data, created_at: new Date().toISOString() }]);
          //update message in thread list
          if (isNewThread) {
            const newThread = {
              ...selectedThread,
              ...response?.data,
              last_message: response?.data?.body,
              last_updated: response?.data?.time,
              created_at: response?.data?.time,
              last_author: generateFullName(userContext?.profileData),
              is_active: true,
            };
            setMessageThreads((pre) => [newThread, ...pre]);
            setIsNewThread(false);
            handleSelectThread(newThread);
          } else {
            setMessageThreads((pre) => {
              // Find the index of the thread we just sent a message to
              const threadIndex = pre.findIndex((item) => item.sk === selectedThread?.sk);

              if (threadIndex === -1) {
                return pre; // Thread not found, return unchanged
              }

              // Update the thread with new message data
              const updatedThread = {
                ...pre[threadIndex],
                last_message: response?.data?.body,
                last_updated: response?.data?.time,
                created_at: response?.data?.time,
                last_message_status: 'queued',
                message_id: response?.data?.message_id,
                last_author: generateFullName(userContext?.profileData),
              };

              // Create new array with updated thread moved to the top
              const newThreads = [...pre];
              newThreads.splice(threadIndex, 1); // Remove thread from current position
              newThreads.unshift(updatedThread); // Add updated thread to the beginning

              return newThreads;
            });
          }
          messageThreads?.length === 0 && fetchTextMessages(selectedContact?.contact_id, true);
          setFile(null);
        }
      })
      .catch((error) => {
        clearTimeout(timeout);
        isFromCase && typeof onOperationBreak === 'function' && onOperationBreak();
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, 'Failed to send the message. ' + error?.response?.data);
      });
  };

  const loadCaseLeadList = (targetUserType, targetUserId, targetUserName) => {
    listCasesForUser(targetUserType, targetUserId, targetUserName, true, true)
      .then((response) => {
        setCaseLeadList(response.data);
      })
      .catch((err) => console.error(err));
  };

  const fileOnChange = async (e) => {
    const file = e?.target?.files?.[0] || e?.dataTransfer?.files?.[0];

    const maxSize = 600 * 1024; // 650 KB in bytes
    if (file?.size < maxSize) {
      setFile(file);
    } else {
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, 'File size must be less than 600KB');
    }
  };

  useEffect(() => {
    if (selectedThread) {
      setMessages([]);
      setFile(null);
      setCurrentOffset(0);
      setHasMoreMessages(true);

      fetchMessageHistory(
        selectedThread?.contact_id,
        false,
        selectedThread?.to?.replace('+1', '')?.replace('+91', ''),
        0, // Start with offset 0
        selectedThread?.unread_reply_count,
        selectedThread?.is_read
      );
      loadCaseLeadList('contact', selectedThread?.contact_id, generateFullName(selectedThread?.client_name));
    }
  }, [selectedThread]);

  const removeFile = () => setFile(null);

  const createNewThread = (newNumber) => {
    setMessages([]);
    setIsNewThread(true);
    handleSelectThread({ ...selectedThread, is_active: true, to: newNumber });
  };

  return (
    <div className="card-bg p-3 mt-3 h-100 d-flex flex-column overflow-hidden">
      <div className="border-bottom">
        <div className="col-12">
          {Boolean(selectedThread) ? (
            <Link
              className="d-flex align-items-center mb-2 text-decoration-none"
              to={selectedThread.contact_id ? `/contacts/${selectedThread.contact_id}` : '/contacts'}
            >
              <ImageComponent
                filePath={`${tenantId}/${selectedThread?.contact_id}/profile_image`}
                fileName={selectedThread?.client_name?.first_name?.charAt(0) ?? 'C'}
                style={{ backgroundColor: '#2196F3', color: '#ffffff' }}
                fileSize="medium.jpg"
              />

              <div className="flex-column ms-3">
                <div className="redirection-link-no-text-transform">
                  <h5 className="caption-bold mb-0 redirection-link-no-text-transform">
                    {generateFullName(selectedThread?.client_name)} ({selectedThread?.to})
                  </h5>
                </div>
                <div className="F-size12">Contact</div>
              </div>
            </Link>
          ) : (
            <div className="d-flex align-items-center mb-2">
              <Avatar size="large" />
            </div>
          )}
        </div>
      </div>

      <div className="d-flex flex-grow-1 mt-2 overflow-hidden">
        <MessageBox
          {...{
            currentOffset,
            hasMoreMessages,
            fileOnChange,
            file,
            removeFile,
            uploadindStatus,
            listRef,
            messages,
            loading,
            fetchMessageHistory,
            createNewThread,
            isNewThread,
            sendMessage,
            navigateToLatest,
            selectedThread,
            newThreadActive,
            caseLeadList,
            isClientOptIn,
          }}
        />
        <div className="col-md-4 col-12 msg-case_details_sidebar ps-md-2 h-100 overflow-y-auto">
          <CaseLeadContainer {...{ caseLeadList }} />
        </div>
      </div>
    </div>
  );
}
